import { useTranslations } from 'hooks/useTranslations';
import * as yup from 'yup';

const useForgotPasswordFormSchema = () => {
  const { t } = useTranslations();
  const schema = yup.object({
    email: yup
      .string()
      .email(t('login.enterEmail.text'))
      .max(254)
      .required(t('login.enterEmail.text')),
  });
  return { schema };
};

export default useForgotPasswordFormSchema;
